(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["post-coffee-subscriptions"] && !Shopify.designMode) return;
  try {
    
// FAQ accordion — single-open behavior, scoped to this section
document.querySelectorAll('.pcc-subs .faq__item').forEach(function (item) {
  var btn = item.querySelector('.faq__q');
  if (!btn) return;
  btn.addEventListener('click', function () {
    var isOpen = item.classList.contains('is-open');
    item.closest('.pcc-subs').querySelectorAll('.faq__item').forEach(function (i) {
      i.classList.remove('is-open');
      var b = i.querySelector('.faq__q');
      if (b) b.setAttribute('aria-expanded', 'false');
    });
    if (!isOpen) {
      item.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
